import { Link } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'
import AccountChip from './AccountChip'
import BalanceChip from './BalanceChip'
import { ActionIcon, Group, Container, Image, Tooltip } from '@mantine/core'
import { LOGO_URL, BRAND_NAME } from '../branding'
import { IconGift } from '@tabler/icons-react'
import NotificationCenter from './NotificationCenter'

export default function Header({ balance, showEarnCreditsCta = false }: { balance?: number; showEarnCreditsCta?: boolean }) {
  const { profile } = useAuth()
  const bal: number | undefined = typeof balance === 'number' ? balance : (typeof profile?.balance === 'number' ? (profile!.balance as number) : undefined)

  return (
    <div style={{ position: 'sticky', top: 0, zIndex: 50, backdropFilter: 'saturate(1.2) blur(6px)', borderBottom: '1px solid var(--border, #e5e7eb)', background: 'rgba(255,255,255,.8)' }}>
      <Container size={1750} px={{ base: 20, sm: 28, lg: 36 }} py="sm">
        <Group justify="space-between" align="center">
          <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
            <Group gap="xs" align="center">
              <Image src={LOGO_URL} alt={`${BRAND_NAME} logo`} w={28} h={28} fit="contain" style={{ display: 'block' }} />
              <div className="brand-lockup">
                <span className="brand-wordmark">{BRAND_NAME}</span>
              </div>
            </Group>
          </Link>
          <Group gap="sm" align="center">
            <NotificationCenter />
            {showEarnCreditsCta && (
              <Tooltip label="Заработать кредиты" withArrow>
                <ActionIcon
                  component={Link}
                  to="/profile?tab=programs"
                  variant="light"
                  color="indigo"
                  size={38}
                  radius="xl"
                  className="header-icon-button"
                  aria-label="Заработать кредиты"
                >
                  <IconGift size={18} />
                </ActionIcon>
              </Tooltip>
            )}
            <BalanceChip amount={bal} />
            <AccountChip />
          </Group>
        </Group>
      </Container>
    </div>
  )
}
